import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { options } from './config';

export type StockDetail = Array<number>;

export type StockColor = {
  line: string;
  gradient: string;
};

const STOCK_GREEN: StockColor = { line: '#30A882', gradient: '#A1D2C3' };
const STOCK_RED: StockColor = { line: '#D0483D', gradient: '#FAE7E5' };

export const getStockColor = (prices: Array<StockDetail>): StockColor => {
  if (prices.length < 2) return STOCK_GREEN;

  const end = prices[prices.length - 1]?.[1] || 0;
  const start = prices[0]?.[1] || 0;
  return start <= end ? STOCK_GREEN : STOCK_RED;
};

export interface StockChartProps {
  stockData: Array<StockDetail>;
  showTimeInToolTip?: boolean;
}

const StockChart: React.FC<StockChartProps> = ({
  stockData,
  showTimeInToolTip = false,
}) => {
  const stockColor = getStockColor(stockData);
  const stockOptions = options([...stockData], stockColor, showTimeInToolTip);
  return (
    <div data-testid="stock-chart">
      <HighchartsReact highcharts={Highcharts} options={{ ...stockOptions }} />
    </div>
  );
};

export { StockChart };
export { StockChartDaily } from './stock-chart-daily';
export { StockChartHomepage } from './stock-chart-homepage';
export { StockChartTable } from './stock-chart-table';
export { GoldSilverChart } from './goldSilverChart';
